<template>
  <the-header />
  <router-view :key="$route.fullPath" :initialSortingMethod="sortingMethod" :initialFilterSettings="filterSettings"
    @onSortingMethodChange="updateSortingMethod" />
</template>

<script>
import TheHeader from './components/TheHeader.vue'

export default {
  name: 'App',
  components: {
    TheHeader,
  },

  data() {
    return {
      filterSettings: {
        title: { displayText: 'title', active: true },
        composer: { displayText: 'composer', active: false },
        librettist: { displayText: 'librettist', active: false },
        performance_year: { displayText: 'year', active: false },
        placename: { displayText: 'city', active: false },
        country: { displayText: 'country', active: false }
      },

      sortingMethod: 'title',
    };
  },

  methods: {
    // filterSettings doesn't need an update method, as the copied prop in operaView references to the objects inside it

    updateSortingMethod(newVal) {
      this.sortingMethod = newVal;
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
}
</style>
